import React from 'react'
import BDDashboard from './BD_Dashboard'

const index = () => <BDDashboard />

export default index